import React, { useEffect, useState } from 'react';
import { AlertCircle } from 'lucide-react';

const FASE_FARVER = {
  '0': '#3b82f6',
  '1': '#22c55e',
  '2': '#f59e0b',
  '3': '#f97316',
  '4': '#a855f7',
  'Ingen fase': '#ef4444',
};

function faseFarve(fase) {
  if (fase === 'Ingen fase') return '#ef4444';
  const match = fase.match(/(\d)/);
  if (match) return FASE_FARVER[match[1]] || '#6b7280';
  return '#6b7280';
}

export default function FaseFunnelAnalysePanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    fetch('/api/os/analyse-extra/fasefunnel', { credentials: 'include' })
      .then(r => r.ok ? r.json() : Promise.reject(r.statusText))
      .then(d => { setData(d); setLoading(false); })
      .catch(e => { setError(String(e)); setLoading(false); });
  }, []);

  if (loading) return <div style={{ color: '#9ca3af', padding: 24 }}>Henter fase-data...</div>;
  if (error) return <div style={{ color: '#ef4444', padding: 24, display: 'flex', alignItems: 'center', gap: 8 }}><AlertCircle size={16} /> {error}</div>;

  const { faser, total, ingen_fase_antal } = data;

  // Sorter: Ingen fase sidst
  const sorted = [...(faser || [])].sort((a, b) => {
    if (a.fase === 'Ingen fase') return 1;
    if (b.fase === 'Ingen fase') return -1;
    return a.fase.localeCompare(b.fase);
  });

  return (
    <div style={{ width: '100%' }}>
      {/* Alarm-badge */}
      {ingen_fase_antal > 0 && (
        <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 8, padding: '10px 14px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
          <AlertCircle size={16} color="#ef4444" />
          <span style={{ color: '#ef4444', fontWeight: 600, fontSize: 13 }}>{ingen_fase_antal} sager uden fase — handling krævet</span>
        </div>
      )}

      {/* Funnel */}
      <div style={{ marginBottom: 8, color: '#9ca3af', fontSize: 12 }}>Total aktive sager: {total}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {sorted.map((fase, i) => {
          const color = faseFarve(fase.fase);
          const widthPct = total > 0 ? Math.max((fase.antal / total) * 100, 8) : 8;
          const isHovered = hovered === i;
          return (
            <div key={i}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{ position: 'relative', cursor: 'default' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 70, color: '#9ca3af', fontSize: 12, textAlign: 'right', flexShrink: 0 }}>{fase.fase}</div>
                <div style={{ flex: 1, background: 'rgba(255,255,255,0.06)', borderRadius: 4, height: 32, position: 'relative', overflow: 'hidden' }}>
                  <div style={{ width: `${widthPct}%`, height: '100%', background: `${color}cc`, borderRadius: 4, transition: 'width 0.4s', display: 'flex', alignItems: 'center', paddingLeft: 10 }}>
                    <span style={{ color: '#fff', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>{fase.antal}</span>
                  </div>
                </div>
                <div style={{ width: 50, color: '#6b7280', fontSize: 12, textAlign: 'right', flexShrink: 0 }}>{fase.pct}%</div>
              </div>
              {isHovered && (
                <div style={{ position: 'absolute', right: 60, top: -28, background: '#1e2235', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8, padding: '6px 10px', color: '#fff', fontSize: 12, zIndex: 10, whiteSpace: 'nowrap' }}>
                  Gns. {fase.gns_dage_i_fase} dage i fasen
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Farveguide */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 16 }}>
        {sorted.map((fase, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <div style={{ width: 10, height: 10, borderRadius: 2, background: faseFarve(fase.fase) }} />
            <span style={{ color: '#9ca3af', fontSize: 11 }}>{fase.fase}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
